import { Form, Typography } from 'antd';
import styled from 'styled-components';

export const Card = styled.div`
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 16px;
`;

export const CardTitle = styled(Typography.Text)`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-self: center;
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 12px;

  input {
    border-radius: 8px;
  }
`;
